import React from "react";
import { Helmet } from "react-helmet";
import { educareLogo } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";

const Careers = () => {
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>Career - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Career" />
      <div className="max-w-screen-2xl h-auto mx-auto pt-4 pb-20">
        <div className="w-full shadow-md shadow-primeColor hover:shadow-darkPink transition-hover duration-300 mx-auto h-full flex flex-col justify-top py-14 px-4 lg:px-32 items-start gap-4">
          <div className="w-full flex flex-col gap-4 md:flex-row justify-between items-center">
            <h1 className="font-titleFont text-4xl font-semibold text-center lg:text-left lg:mb-4 underline-none lg:underline underline-offset-8 decoration-[1px] decoration-gray-400">
              Career with EduCare English Learning Academy
            </h1>
            <img className="w-52" src={educareLogo} alt="educareLogo" />
          </div>
          <div className="w-full">
            <p className="font-bodyFont text-l text-center lg:text-left text-gray-600 tracking-wide">
              Right now we are not Hiring.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
